import { defineComponent, openBlock, createElementBlock, createElementVNode } from 'vue';
import _export_sfc from './_virtual/plugin-vue_export-helper.mjs';

const _sfc_main = defineComponent({
  name: "Minus"
});
const _hoisted_1 = {
  class: "icon",
  width: "200px",
  height: "200.00px",
  viewBox: "0 0 1024 1024",
  version: "1.1",
  xmlns: "http://www.w3.org/2000/svg"
};
const _hoisted_2 = /* @__PURE__ */ createElementVNode("path", {
  d: "M128 544h768q14.016 0 23.008-8.992T928 512t-8.992-23.008T896 480H128q-14.016 0-23.008 8.992T96 512t8.992 23.008T128 544z",
  fill: "currentColor"
}, null, -1);
const _hoisted_3 = [
  _hoisted_2
];
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createElementBlock("svg", _hoisted_1, _hoisted_3);
}
var minus = /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render], ["__file", "E:\\gitlab\\sgui-plus-icon\\packages\\vue\\src\\minus.vue"]]);

export { minus as default };
